import { useEffect,useState } from 'preact/hooks';
import { Button } from '@/ui/components';
import { UI_PANEL_BORDER } from '@/ui/consts';
import { useClient } from '@/ui/context';
import { clearPrivateRoom,getPrivateRoom,sendRoomAction,subscribePrivateRoom } from '@/private-rooms';
import { DialogBase } from './dialog-base';
import { HouseDesignPanel } from '@/ui/components/house-design-panel';

export function PrivateRoomDialog(){
  const client=useClient();const [,redraw]=useState(0);const [amount,setAmount]=useState('1');
  const [guestName,setGuestName]=useState('');
  const [salePrice,setSalePrice]=useState('0');
  useEffect(()=>{
    const off=subscribePrivateRoom(client,()=>redraw(n=>n+1));let map=client.mapId;
    sendRoomAction(client,'room_view');
    const timer=window.setInterval(()=>{
      if(!client.worldLoading&&client.mapId!==map){map=client.mapId;clearPrivateRoom(client);sendRoomAction(client,'room_view');}
    },600);
    return ()=>{off();clearInterval(timer);};
  },[client]);
  const {snapshot,pending}=getPrivateRoom(client);
  const quantity=()=>/^\d+$/.test(amount)&&Number.isSafeInteger(Number(amount))&&Number(amount)>0?amount:null;
  const move=(direction:'deposit'|'withdraw',kind:string,id?:number)=>{
    if(kind==='instance'){sendRoomAction(client,`vault_${direction}`,`instance:${id}`);return;}
    const count=quantity();if(count)sendRoomAction(client,`vault_${direction}`,kind==='gold'?`gold:${count}`:`item:${id}:${count}`);
  };
  return <DialogBase id='privateRoom' title={snapshot?.inside&&snapshot.room_type==='guild'?'Guild vault':'Home'} size='lg' touchScroll>
    <div class='flex flex-col gap-3 p-3 text-sm'>
      {snapshot?.inside&&<p>{snapshot.room_type==='guild'?'Your guild’s shared vault.':'Speak to Bank Bob to use your normal personal bank and vault.'}</p>}
      {!snapshot?.inside&&<>
        <h3 class='font-bold'>Your houses</h3>
        <p>Each key owns a separate house. Double-click a key to enter. Leaving returns you to where you entered.</p>
        <p>Buy a home from Fred The Homesteader in the Aeven temple.</p>
      </>}
      {!!snapshot?.house_keys?.length&&<>
        <h3 class='font-bold'>House guests</h3>
        <label>Guest character name <input class={`input input-sm input-bordered border ${UI_PANEL_BORDER}`} maxLength={16} value={guestName}
          onInput={e=>setGuestName(e.currentTarget.value.replace(/[^a-z]/gi,''))}/></label>
        <p>Invitations last five minutes. Guests cannot use your vault or edit your house. Revoke removes a guest from the house.</p>
        {snapshot.house_keys.map(key=><div key={key} class='flex flex-wrap gap-2'>
          <span>House #{key}</span>
          <Button variant={['sm']} disabled={pending||!guestName} onClick={()=>sendRoomAction(client,'house_invite',`${key}:${guestName}`)}>Invite</Button>
          <Button variant={['sm']} disabled={pending||!guestName} onClick={()=>sendRoomAction(client,'house_revoke',`${key}:${guestName}`)}>Revoke</Button>
        </div>)}
      </>}
      {!snapshot?.inside&&!!snapshot?.house_invitations?.length&&<>
        <h3 class='font-bold'>House invitations</h3>
        {snapshot.house_invitations.map(invite=><Button key={invite.key} variant={['sm']} disabled={pending}
          onClick={()=>sendRoomAction(client,'house_visit',String(invite.key))}>Visit {invite.host_name}'s house #{invite.key}</Button>)}
      </>}
      {!snapshot?.inside&&!!snapshot?.house_keys?.length&&<>
        <h3 class='font-bold'>Transfer a house</h3>
        <p>Use the character name above as buyer. Stand beside them. Empty the house vault and have everyone leave first. The house design transfers with its key.</p>
        <label>Agreed price (0 to gift) <input class={`input input-sm input-bordered border ${UI_PANEL_BORDER} w-32`} inputMode='numeric' value={salePrice}
          onInput={e=>setSalePrice(e.currentTarget.value.replace(/\D/g,''))}/></label>
        {snapshot.house_keys.map(key=><Button key={key} variant={['sm']} disabled={pending||!guestName||!/^\d+$/.test(salePrice)||Number(salePrice)>2147483647}
          onClick={()=>client.alertController.showConfirm('Offer house transfer',`Offer house #${key} to ${guestName} for ${salePrice} gold? They must accept.`,confirmed=>{
            if(confirmed)sendRoomAction(client,'house_offer',`${key}:${guestName}:${salePrice}`);
          })}>Offer house #{key}</Button>)}
      </>}
      {snapshot?.house_offer&&<div class={`border ${UI_PANEL_BORDER} p-2`}>
        <h3 class='font-bold'>House offer from {snapshot.house_offer.seller}</h3>
        <p>House #{snapshot.house_offer.key} — {snapshot.house_offer.price.toLocaleString()} gold. Accepting transfers the gold immediately and gives you its key and house.</p>
        <div class='flex gap-2'><Button variant={['sm']} disabled={pending} onClick={()=>{
          const offer=snapshot.house_offer!;
          client.alertController.showConfirm('Accept house transfer',`Pay ${offer.price.toLocaleString()} gold for house #${offer.key}?`,confirmed=>{
            if(confirmed)sendRoomAction(client,'house_accept',offer.operation);
          });
        }}>Accept</Button><Button variant={['sm']} disabled={pending} onClick={()=>sendRoomAction(client,'house_decline',snapshot.house_offer!.operation)}>Decline</Button></div>
      </div>}
      {snapshot?.error&&<p role='alert' class='text-warning'>{snapshot.error}</p>}
      {snapshot?.house_design&&<HouseDesignPanel house={snapshot.house_design} pending={pending}/>}
      <div class='flex flex-wrap gap-2'>
        <Button variant={['sm']} disabled={pending} onClick={()=>sendRoomAction(client,'room_view')}>Refresh</Button>
        {snapshot?.inside&&<Button variant={['sm']} disabled={pending} onClick={()=>sendRoomAction(client,'room_leave')}>Leave</Button>}
      </div>
      {pending&&<p>Saving vault changes…</p>}
      {snapshot?.gold!==undefined&&<>
        <label>Transfer amount <input class={`input input-sm input-bordered border ${UI_PANEL_BORDER} w-32`} inputMode='numeric' value={amount}
          onInput={e=>setAmount(e.currentTarget.value.replace(/\D/g,''))}/></label>
        <p>Vault gold: {snapshot.gold}</p>
        <div class='flex gap-2'><Button variant={['sm']} disabled={pending} onClick={()=>move('deposit','gold')}>Deposit gold</Button>
          <Button variant={['sm']} disabled={pending} onClick={()=>move('withdraw','gold')}>Withdraw gold</Button></div>
        <h3 class='font-bold'>Stored items</h3>
        <div class='max-h-44 overflow-y-auto'>
          {snapshot.items?.map(item=><div key={item.id} class='flex items-center justify-between gap-2 py-1'>
            <span>{item.name} × {item.amount}</span><Button variant={['xs']} disabled={pending} onClick={()=>move('withdraw','item',item.id)}>Withdraw</Button></div>)}
          {snapshot.instances?.map(item=><div key={`instance-${item.id}`} class='flex items-center justify-between gap-2 py-1'>
            <span>{item.name} +{item.upgrade} (#{item.id})</span><Button variant={['xs']} disabled={pending} onClick={()=>move('withdraw','instance',item.id)}>Withdraw</Button></div>)}
        </div>
        <h3 class='font-bold'>Your inventory</h3>
        <div class='max-h-44 overflow-y-auto'>
          {snapshot.inventory.filter(item=>item.id!==1&&item.id!==snapshot.key_item_id).map(item=><div key={item.id} class='flex items-center justify-between gap-2 py-1'>
            <span>{item.name} × {item.amount}</span><Button variant={['xs']} disabled={pending} onClick={()=>move('deposit','item',item.id)}>Deposit plain items</Button></div>)}
          {snapshot.equipment.filter(item=>item.item_id!==snapshot.key_item_id).map(item=><div key={`instance-${item.id}`} class='flex items-center justify-between gap-2 py-1'>
            <span>{item.name} +{item.upgrade} (#{item.id})</span><Button variant={['xs']} disabled={pending} onClick={()=>move('deposit','instance',item.id)}>Deposit equipment</Button></div>)}
        </div>
      </>}
    </div>
  </DialogBase>;
}
